require('./bootstrap');
import Echo from "laravel-echo"
window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: hostvars['lindworm_host']
});


// WEBPACK FOOTER //
// ./resources/assets/js/core.js